import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight, faCartShopping  } from  "@fortawesome/free-solid-svg-icons";
import { faHeart  } from  "@fortawesome/free-solid-svg-icons";
import { faStore  } from  "@fortawesome/free-solid-svg-icons";
import { faMagnifyingGlass  } from  "@fortawesome/free-solid-svg-icons";
import { faUser  } from  "@fortawesome/free-solid-svg-icons";
import { faArrowLeft  } from  "@fortawesome/free-solid-svg-icons";
import { faStar  } from  "@fortawesome/free-solid-svg-icons";
import { faStar as farStar  } from  "@fortawesome/free-regular-svg-icons";
import { faHeart as farHeart  } from  "@fortawesome/free-regular-svg-icons";
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { faCircleMinus } from '@fortawesome/free-solid-svg-icons';




library.add(faCartShopping );
library.add(faHeart );
library.add(faMagnifyingGlass );
library.add(faStore );
library.add(faArrowLeft );
library.add(faArrowRight);
library.add(faLinkedin);
library.add(faTwitter);
library.add(faInstagram);
library.add(faGithub);
library.add(faFilter);
library.add(faStar);
library.add(farStar);
library.add(faHeart);
library.add(farHeart);
library.add(faCirclePlus);
library.add(faCircleMinus);
library.add(faUser);
